export const fetchPlacementDataAdminHub = (
	path: string,
	requestOptions?: RequestInit,
	fetcher: (
		...params: Parameters<typeof fetch>
	) => Promise<Response | undefined> | undefined = globalThis.fetch,
): Promise<Response | undefined> | undefined => {
	const defaultHeaders = {
		credentials: 'include',
		mode: 'cors',
		'Content-Type': 'application/json',
	};

	return fetcher(path, {
		...requestOptions,
		headers: {
			...defaultHeaders,
			...requestOptions?.headers,
		},
	});
};
